import React, {useRef, useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  }
}));

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default function StepList(props) {
  const classes = useStyles();

  const ajax = props.ajax;

  const [isLoaded, setIsLoaded] = useState(false);
  const [sourceType, setSourceType] = useState('array');
  const [sourceOp, setSourceOp] = useState(null);
  const [sourceParams, setSourceParams] = useState(null);
  const [options, setOptions] = useState([]);
  const ignoredOptionProperties = ['id', 'label', 'nextStep'];

  const prevValues = usePrevious({sourceType, sourceOp, sourceParams});

  useEffect(() => {
    if (!props.step)
      return;

    if (prevValues
      && JSON.stringify(prevValues.sourceType) === JSON.stringify(sourceType)
      && JSON.stringify(prevValues.sourceOp) === JSON.stringify(sourceOp)
      && JSON.stringify(prevValues.sourceParams) === JSON.stringify(sourceParams)
    )
      return;

    console.log('New source values:', props, prevValues, props.sourceType, props.sourceOp, props.sourceParams);
    switch (props.sourceType) {
      // case 'ajax':
      //   console.log(prevValues, props.sourceType, props.sourceOp, props.sourceParams);
      //   ajax(props.sourceOp, props.sourceParams)
      //     .then(response => {
      //       props.onOptionsChange(props.step.name, response.data);
      //     });
      //   setSourceType(props.sourceType);
      //   setSourceOp(props.sourceOp);
      //   setSourceParams(props.sourceParams);
      //   break;

      default:
        setOptions(props.step.options.filter(filterOptions));
        setIsLoaded(true);
    }
  }, [props, prevValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.onChange && options.length === 1)
      props.onChange(options[0]);
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterOptions = option => {
    // verificam daca in props.data exista o proprietate cu numele diferit de id, label sau nextStep si filtram dupa caz
    const keys = Object.keys(option).filter(key => !~ignoredOptionProperties.indexOf(key));
    for (let i = 0; i < keys.length; i++) {
      if (props.data.hasOwnProperty(keys[i]) && option[keys[i]] !== props.data[keys[i]])
        return false;
    }
    return true;
  };

  const handleStepComplete = (option) => () => {
    props.onChange(option);
  };

  if (!isLoaded)
    return null;

  return (
    <List dense>
      {options.map(props.step.optionsMap).map(option =>
        <ListItem key={option.id} dense button className={classes.listItemDense}
          onClick={handleStepComplete(option)}
        >
          <ListItemText className={classes.listItemTextDense}
            primary={option.label}
            secondary={option.helper}
          />
        </ListItem>
      )}
    </List>
  );
}